import { useState } from "react";

import { API_EQUIPMENT, API_IMPORT_CSV, BASE_ADMIN, BASE_URI } from "../constants/api";
import { RequestError } from "../errors/RequestError";

import useAuth from "./useAuth";

type ImportEquipmentCsvResponse = {
  message: string;
  imported: number;
  updated: number;
  skipped: number;
  total: number;
};

const useImportEquipmentCsv = () => {
  const { token } = useAuth();

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<ImportEquipmentCsvResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const upload = (file: File) => {
    const headers = new Headers();

    if (!token) {
      const errorToken = new RequestError("Vous n'êtes pas autorisé à importer un CSV", 401);
      setError(errorToken);
      return;
    }

    headers.set("Authorization", "Bearer " + token);

    const formData = new FormData();
    formData.append("csvFile", file);

    setLoading(true);
    setError(null);
    setResponse(null);

    fetch(`${BASE_URI}/${BASE_ADMIN}/${API_EQUIPMENT}/${API_IMPORT_CSV}`, {
      method: "POST",
      body: formData,
      headers,
      mode: "cors",
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        }

        return res.text().then((text) => {
          const parsedError = JSON.parse(text);
          throw new RequestError(parsedError.message ?? "Erreur lors de l'import du CSV", res.status);
        });
      })
      .then((data: ImportEquipmentCsvResponse) => setResponse(data))
      .catch((requestError) => {
        setError(requestError);
        setResponse(null);
      })
      .finally(() => setLoading(false));
  };

  return { loading, error, response, upload };
};

export default useImportEquipmentCsv;
